import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { AppLocale } from '../lib/locale';
import { localeFromPathname } from '../lib/locale';

export function useAppLocale(): AppLocale {
  const { pathname } = useLocation();
  return useMemo(() => localeFromPathname(pathname), [pathname]);
}
